import { ConditionalLink } from "components/conditionalLink";
import { Preview } from "components/PreviewModal";
import { useModal } from "hooks/useModal";
import React from "react";
import { FileObject } from "types/Models/fileObject";

export const FinancialView = ({
  item,
}: {
  item: { file_url?: string | null; file_data?: FileObject | null };
}) => {
  const previewModal = useModal();
  return (
    <section>
      {item?.file_url ? (
        <ConditionalLink
          onClick={(e) => {
            e.stopPropagation();
          }}
          to={item?.file_url}
          target="_blank"
        >
          <span className="t-text-purple-70 t-text-body-sm t-font-medium t-no-underline hover:t-underline">
            View in live financials
          </span>
        </ConditionalLink>
      ) : (
        <span
          onClick={previewModal.open}
          className="t-text-purple-70 t-cursor-pointer t-text-body-sm t-font-medium t-no-underline hover:t-underline"
        >
          View document
        </span>
      )}
      <Preview
        showModal={previewModal.isOpen}
        closeModal={previewModal.close}
        previewId={item.file_data?.uuid}
      />
    </section>
  );
};
